export default __webpack_public_path__ + "static/media/37t.cef73506.jpg";